import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBundle } from "../../../_actions/bundle.actions";
import { Courses } from "../Courses";

const BundlesContainer = () => {
  const dispatch = useDispatch();

  const bundleCourses = useSelector((state) => {
    const { bundleCourses, loading } = state?.bundleCourses;
    //console.log("bundleCourses",bundleCourses);
    return {
      bundleCourses: bundleCourses,
      loading:loading
    };
  });

  useEffect(() => {
    dispatch(fetchBundle());
  }, []);

  return (
    <>
      <Courses
        courses={bundleCourses}
        varient="courses"
        title="Bundle Courses"
        bundle={true}
      />
    </>
  );
};

export default BundlesContainer;
